import './styles/style.css';
// import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import AppLayout from './pages/Layouts/App';
import AnalyticsTracker from './components/Analytics/AnalyticsTracker';



function App() {
  return (
    <div className="App">
      <AnalyticsTracker />
      <AppLayout />
    </div>
  );
}

export default App;
